import { X } from 'lucide-react';
import { clsx } from '../../utils/cn.js';

export default function Modal({ open, title, children, onClose, wide }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        aria-label="Cerrar"
        onClick={onClose}
      />
      <div
        className={clsx(
          'relative z-10 max-h-[90vh] w-full overflow-y-auto rounded-2xl border border-white/15 bg-slate-950 p-6 shadow-premium ring-1 ring-brand-navy/30',
          wide ? 'max-w-4xl' : 'max-w-lg'
        )}
        role="dialog"
        aria-modal="true"
      >
        <div className="mb-4 flex items-start justify-between gap-4">
          <h2 className="font-display text-xl font-semibold text-white md:text-2xl">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 text-slate-400 transition hover:bg-white/10 hover:text-white"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
